import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class RelatorioBeneficiariosService extends Service {
  async consultarBeneficiariosGeral (filter) {
    let beneficiarios = [];
    let result = await this.getRelatorioBeneficiariosApi().consultarBeneficiariosGeral(filter);
    beneficiarios = result;
    return beneficiarios;
  }
  async consultarBeneficiariosJson (filter) {
    let beneficiarios = [];
    let result = await this.getRelatorioBeneficiariosApi().consultarBeneficiariosGeral(filter);
    for (var i = 0; i < result.length; i++) {      
      let beneficiariosAux = result[i].nome.split(';');
      if (beneficiariosAux[0] !== 'MATRICULA') {
        let matricula = beneficiariosAux[0];
        let nome = beneficiariosAux[1];
        let cpf = beneficiariosAux[2];
        let titularidade = beneficiariosAux[3];
        let dataNasc = beneficiariosAux[4];
        let idade = beneficiariosAux[5];
        let estadoCivil = beneficiariosAux[6];
        let sexo = beneficiariosAux[7];
        let parentesco = beneficiariosAux[8];
        let dataInicio = beneficiariosAux[9];
        let dataFim = beneficiariosAux[10];

        beneficiarios.push({matricula: matricula,
        nome: nome,
        cpf: cpf,
        titularidade: titularidade,
        dataNasc: dataNasc,
        idade: idade,
        estadoCivil: estadoCivil,
        sexo: sexo,
        parentesco: parentesco,
        dataInicio: dataInicio,
        dataFim: dataFim});  
      }
    }
    return beneficiarios;
  }
}
export default RelatorioBeneficiariosService;
